import { Component, OnInit, Inject, ViewEncapsulation, AfterViewInit, ViewChildren, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DocumentService } from 'src/app/core/services/document.service';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { ResponsiveService } from 'src/app/core/services/responsive.service';

// Jquery function for disabling radio and checkbox
declare function disableFormFields(): any;

// Jquery function for disabling input
declare function disableFormInput(): any;

@Component({
  selector: 'app-view-pdf',
  templateUrl: './view-pdf.component.html',
  styleUrls: ['./view-pdf.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ViewPdfComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * contructor liblary BlockUI
   */
  @BlockUI() blockUI: NgBlockUI;

  /**
   * String html inner for div
   */
  src: '';

  documentName: ''

  pdfSize: number;

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  constructor(
    public deviceService: DeviceDetectorService,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<ViewPdfComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private responsiveService: ResponsiveService
  ) {
    dialogRef.disableClose = false;
    this.pdfSize = 1;
   }

  /**
   * Init component
   */
  ngOnInit() {
    this.blockUI.start('');
    this.viewHtml();
    this.documentName = this.data.name;
  }

  @ViewChildren('focus') focus;
  ngAfterViewInit() {
    setTimeout(_ => this.focus.first.nativeElement.focus(), 200);

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.pdfSize = this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? 0.7 : 1;
        }
      }
    );
  }

  ngOnDestroy() {
    this.subscribeMediaBreakPointService.unsubscribe();
  }

  /**
   * Get html
   */
  viewHtml() {
    if (this.data) {
      if (this.data.isSystem) {
        // Get html of system
        this.documentService.getHtmlOfDocumentSystem(this.data.id).subscribe(
          rs => {
            this.assginSrc(rs);
          }
        );
      } else {
        // Get html of enterprise
        this.documentService.getDocumentTypeById(this.data.id).subscribe(
          rs => {
            this.assginSrc(rs);
          }
        );
      }
    } else {
      this.dialogRef.close();
    }
  }

  /**
   * Assign src = rs
   * @param rs html after request Api
   */
  assginSrc(rs) {
    if (rs) {
      this.src = rs;
      disableFormFields();
      disableFormInput();
      setTimeout(() => {
        this.blockUI.stop();
      }, 1);
    } else {
      this.dialogRef.close();
    }
  }
}
